import { Container, Grid, List, ListItem } from '@material-ui/core';
import { ControlPoint, ExpandMore } from '@material-ui/icons';
import classNames from 'classnames';
import React, { useState } from 'react';

import { Button } from '@components/Button';
import { Link } from '@components/Link';
import { Logo } from '@components/Logo';
import { SideBar } from '@components/SideBar';
import { Typography } from '@components/Typography';
import {
  useAuthContext,
  useFullWidthPath,
  useHideLocalUrls,
  useIsMdUp,
  useIsXsDown,
  useWindowScroll,
} from '@hooks';
import { loginUrl, offerCreateUrl, priceListUrl } from '@urls';
import { getTestAttribute } from '@utils/misc';

import userSvg from 'assets/user.svg';

import useStyles, { HEADER_HEIGHT } from './styles';

export { HEADER_HEIGHT };

export const Header: React.FC<{ nav: boolean }> = ({ nav = true }) => {
  const fullWidth = useFullWidthPath();
  const [showDrawer, setShowDrawer] = useState(false);
  const authContext = useAuthContext();
  const isMedium = useIsMdUp();
  const isXs = useIsXsDown();
  const { scrollY } = useWindowScroll();
  const classes = useStyles();
  const { loading, user, isLoggedIn } = authContext;
  const displayName =
    user?.fullName?.trim() ||
    [user?.firstName, user?.lastName].filter(Boolean).join(' ').trim() ||
    'Użytkownik';
  const compact = !!scrollY;
  const hideLocalUrls = useHideLocalUrls();

  return (
    <Container
      maxWidth={fullWidth ? false : undefined}
      component="header"
      className={classes.container}
    >
      <Grid container justify="space-between" alignItems="center" style={{ height: 'inherit' }}>
        <Grid item xs="auto">
          <Logo />
        </Grid>
        <Grid item xs="auto">
          {nav && (
            <List disablePadding className={classes.list}>
              {isMedium && hideLocalUrls === false && (
                <ListItem
                  disableGutters={!isMedium}
                  className={classNames(classes.listItemPrice, {
                    [classes.listItemCompact]: compact,
                  })}
                  component={Link}
                  to={priceListUrl}
                >
                  <Button>Cennik</Button>
                </ListItem>
              )}
              {user ? (
                <ListItem
                  disableGutters={!isMedium}
                  className={classNames(classes.listItem, {
                    [classes.listItemCompact]: compact,
                  })}
                  onClick={() => setShowDrawer(true)}
                >
                  <Button
                    {...getTestAttribute('btn', 'userPanel')}
                    size={isXs ? 'small' : 'medium'}
                  >
                    <img src={userSvg} alt="User" className={classes.userIcon} />
                    {isMedium && (
                      <Typography fontWeight="bold" color="primary">
                        {displayName}
                      </Typography>
                    )}
                    {!isXs && <ExpandMore color="primary" />}
                  </Button>
                </ListItem>
              ) : (
                <ListItem
                  disableGutters={!isMedium}
                  className={classNames(classes.listItem, {
                    [classes.listItemCompact]: compact,
                  })}
                  component={Link}
                  to={loading ? '#' : loginUrl}
                  disabled={loading}
                >
                  <Button {...getTestAttribute('btn', 'login')}>Zaloguj się</Button>
                </ListItem>
              )}
              {isMedium && (
                <ListItem
                  disableGutters={!isMedium}
                  className={classNames(classes.listItem, {
                    [classes.listItemCompact]: compact,
                  })}
                  component={Link}
                  to={loading ? '#' : offerCreateUrl}
                  {...getTestAttribute('btn', 'publishOffer')}
                  disabled={loading}
                >
                  <Button variant="contained" color="primary" endIcon={<ControlPoint />}>
                    Opublikuj ofertę
                  </Button>
                </ListItem>
              )}
            </List>
          )}
        </Grid>
      </Grid>
      {isLoggedIn && (
        <SideBar open={showDrawer} toggleOpen={setShowDrawer} authContext={authContext} />
      )}
    </Container>
  );
};
